/* eslint-disable react-hooks/exhaustive-deps */
// Flujo Rep. Legal diferente a Aval y aval casado por bientes mancomunados
// Flujo Rep. Legal es el mismo que el Aval y aval casado por bientes mancomunados
// Flujo Rep. Legal es el mismo que el Aval
// Flujo Rep. Legal diferente a Aval

import { Box, ListItemIcon, Typography, useMediaQuery, useTheme } from "@mui/material";

interface ListDocumentsProps {
  title: string;
  documents?: string[];
  showLegend?: boolean;
}

interface ListIconProps {
  color: string;
}

const ListIcon = ({ color }: ListIconProps) => {
  return (
    <ListItemIcon sx={{ minWidth: "15px" }}>
      <Box width={12} height={12} sx={{ backgroundColor: color }}></Box>
    </ListItemIcon>
  );
};

const ListDocuments = ({ title, documents, showLegend = false }: ListDocumentsProps) => {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <Box>
      <Box display="flex" alignItems="center">
        <Box width={"20px"}>
          <ListIcon color={theme?.palette?.primary?.main} />
        </Box>
        <Typography
          variant={isMobileOrTablet ? "body3" : "body2"}
          color={theme?.palette?.primary?.dark}
          fontWeight={300}
        >
          {title}
        </Typography>
      </Box>
      {documents && documents.length > 0 && showLegend && (
        <Box display="flex" alignItems="center">
          <Box width={"20px"}></Box>
          <Typography variant="caption" color={theme?.palette?.primary?.dark} fontWeight={300}>
            Archivos que incluye:
          </Typography>
        </Box>
      )}
      {documents?.map((docName, index) => (
        <Box key={index} display="flex" alignItems="center" pl={2}>
          <ListIcon color={theme?.palette?.primary?.light} />
          <Typography
            variant={isMobileOrTablet ? "body3" : "body2"}
            color={theme?.palette?.primary?.dark}
            fontWeight={300}
          >
            {docName}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default ListDocuments;
